import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
import { o as otto } from "../chunks/common-nexus-client-CdICzBNm.mjs";
const onexSync = o_util.onex ?? {};
const isOnexVariant = onexSync.isOnexVariant;
const mapOnexVariant = onexSync.mapOnexVariant;
const withOnex = onexSync.withOnex;
const customAssignments = onexSync.customAssignments;
const onexAsync = otto.onex ?? {};
const assignments = onexAsync.assignments;
export {
  assignments,
  customAssignments,
  isOnexVariant,
  mapOnexVariant,
  onexAsync,
  onexSync,
  withOnex
};
/*                                    */
